module.exports = __webpack_public_path__ + "img/icon_map_xmmg_c.a05d7cc5.png";